<div class="date-range-filter">
  <form [formGroup]="dateForm">
    <mat-form-field appearance="outline">
      <span matPrefix class="range-icon material-symbols-outlined" aria-hidden="true"
        >calendar_month</span
      >
      <mat-select
        formControlName="dateRangeControl"
        disableRipple
        hideSingleSelectionIndicator
        (selectionChange)="selectRange()"
        data-test-id="date-range-select"
      >
        <mat-option
          *ngFor="let dateRange of dateRanges"
          [value]="dateRange"
          [attr.data-test-id]="'date-range-option-' + dateRange"
          >{{ dateRange }}</mat-option
        >
      </mat-select>
      <mat-icon matSuffix class="select-icon-replacement">expand_more</mat-icon>
    </mat-form-field>
  </form>
</div>
